import { createContext, useReducer } from "react";
import { v4 as uuidv4 } from "uuid";

export const Store = createContext();

const initialState = {
  messages: localStorage.getItem("messages")
    ? JSON.parse(localStorage.getItem("messages"))
    : [],
  clients: localStorage.getItem("clients")
    ? JSON.parse(localStorage.getItem("clients"))
    : [],

  userInfo: localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null,
  carts: localStorage.getItem("carts")
    ? JSON.parse(localStorage.getItem("carts"))
    : [...Array(400).keys()].map((v, i) => ({
        cartItems: [],
        tableNum: i + 1,
      })),
  table: localStorage.getItem("table")
    ? parseInt(localStorage.getItem("table"))
    : 0,
  categoryHistory: localStorage.getItem("categoryHistory")
    ? JSON.parse(localStorage.getItem("categoryHistory"))
    : [],

  historicMod: localStorage.getItem("historicMod")
    ? localStorage.getItem("historicMod") === "true"
      ? true
      : false
    : false,
  compartments: localStorage.getItem("compartments")
    ? JSON.parse(localStorage.getItem("compartments"))
    : null,
  users: localStorage.getItem("users")
    ? JSON.parse(localStorage.getItem("users"))
    : undefined,
  tableUsers: localStorage.getItem("tableUsers")
    ? JSON.parse(localStorage.getItem("tableUsers"))
    : undefined,
  tableTypes: localStorage.getItem("tableTypes")
    ? JSON.parse(localStorage.getItem("tableTypes"))
    : undefined,
  tableTypesAll: localStorage.getItem("tableTypesAll")
    ? JSON.parse(localStorage.getItem("tableTypesAll"))
    : undefined,
  products: localStorage.getItem("products")
    ? JSON.parse(localStorage.getItem("products"))
    : null,
  mostUsedProducts: localStorage.getItem("mostUsedProducts")
    ? JSON.parse(localStorage.getItem("mostUsedProducts"))
    : [],
  categories: localStorage.getItem("categories")
    ? JSON.parse(localStorage.getItem("categories"))
    : null,
  allCategories: localStorage.getItem("allCategories")
    ? JSON.parse(localStorage.getItem("allCategories"))
    : null,
  leafCategories: localStorage.getItem("leafCategories")
    ? JSON.parse(localStorage.getItem("leafCategories"))
    : null,
};
function reducer(state, action) {
  switch (action.type) {
    case "ADD_MESSAGE":
      const messages = [...state.messages, action.payload];
      localStorage.setItem("messages", JSON.stringify(messages));
      return { ...state, messages };
    case "SET_CLIENTS": {
      let clients = action.payload.clients;
      localStorage.setItem("clients", JSON.stringify(clients));
      return { ...state, clients };
    }
    case "CLIENT_SEEN": {
      const clientFound = state.clients.filter(
        (c) => c._id === action.payload._id
      );

      if (clientFound.length > 0) {
        let clients = state.clients.map((c) =>
          c._id === action.payload._id
            ? { ...c, lastSeen: new Date(), token: action.payload.token }
            : { ...c }
        );
        localStorage.setItem("clients", JSON.stringify(clients));
        return { ...state, clients };
      } else {
        let clients = [...state.clients, action.payload];
        localStorage.setItem("clients", JSON.stringify(clients));
        return { ...state, clients };
      }
    }
    case "SET_MESSAGES": {
      let messages = [...state?.messages, ...action.payload.messages];

      messages = Array.from(new Set(messages.map((obj) => obj.message.id))).map(
        (id) => {
          return messages.find((obj) => obj.message.id === id);
        }
      );

      messages.sort(
        (a, b) =>
          new Date(a.message.date).getTime() -
          new Date(b.message.date).getTime()
      );

      localStorage.setItem("messages", JSON.stringify(messages));

      return { ...state, messages };
    }
    case "READ_MESSAGES": {
      const messages = state.messages.map((m) => {
        if (m.user.id === action.payload.userId) {
          return { ...m, read: true };
        } else {
          return { ...m };
        }
      });

      localStorage.setItem("messages", JSON.stringify(messages));
      return { ...state, messages };
    }
    case "READ_MESSAGES_NOT": {
      const messages = state.messages.map((m) => {
        if (m.user.id !== action.payload.userId) {
          return { ...m, read: true };
        } else {
          return { ...m };
        }
      });

      localStorage.setItem("messages", JSON.stringify(messages));
      return { ...state, messages };
    }
    case "RECIPIENT_READED_MESSAGES": {
      const messagesReaded = action.payload;
      const messages = state.messages.map((m) => {
        if (messagesReaded.includes(m.message.id)) {
          return { ...m, read: true };
        } else {
          return { ...m };
        }
      });

      localStorage.setItem("messages", JSON.stringify(messages));
      return { ...state, messages };
    }
    case "CART_ADD_ITEM":
      const carts = state.carts.map((e, i) => {
        if (i + 1 === action.payload.tableNum) {
          let orderCode = e.orderCode || action.payload.orderCode;

          const cartItems = [...e.cartItems, { ...action.payload }];
          return {
            ...e,
            cartItems,
            tableCode: action.payload.tableCode,
            tableNum: action.payload.tableNum,
            orderCode,
          };
        } else {
          return { ...e };
        }
      });
      const resultState = { ...state, carts: [...carts] };
      localStorage.setItem("carts", JSON.stringify(resultState.carts));
      return resultState;

    case "CUSTOMER_CART_ADD_ITEM": {
      let tableNum;
      if (!action.payload.tableNum) {
        const foundCarts = state.carts.filter(
          (c) => c.clientCode === action.payload.clientCode
        );
        if (foundCarts.length > 0) {
          tableNum = foundCarts[0].tableNum;
        } else {
          for (let index = 300; index < 400; index++) {
            if (state.carts[index].cartItems.length === 0) {
              tableNum = index + 1;
              break;
            }
          }
        }
      }

      tableNum = tableNum || action.payload.tableNum;

      const items = state.carts[tableNum - 1].cartItems.filter(
        (i) => action.payload.itemCode === i.itemCode
      );

      if (items.length === 0) {
        const carts = state.carts.map((e, i) => {
          if (i + 1 === parseInt(tableNum)) {
            const cartItems = [...e.cartItems, action.payload];
            return {
              ...e,
              cartItems,
              tableCode: action.payload.tableCode || action.payload.clientCode,
              tableNum: tableNum,
              clientCode: action.payload.clientCode,
              alert: action.payload.alert,
              orderCode: uuidv4(),
            };
          } else {
            return { ...e };
          }
        });
        const resultState = { ...state, carts: [...carts] };
        localStorage.setItem("carts", JSON.stringify(resultState.carts));
        return resultState;
      } else {
        const updatedCartItems = state.carts[tableNum - 1].cartItems.map(
          (i) => {
            if (
              action.payload.itemCode === i.itemCode &&
              (action.payload.quantity !== i.quantity ||
                (i.feature && action.payload.price !== i.feature.price))
            ) {
              return {
                ...i,
                quantity: action.payload.quantity,
                feature: {
                  ...i.feature,
                  mainPrice: i.feature.mainPrice || i.feature.price,
                  price: action.payload.feature.price,
                },
              };
            } else if (
              action.payload.itemCode === i.itemCode &&
              (action.payload.quantity !== i.quantity ||
                (!i.feature && action.payload.price !== i.price))
            ) {
              return {
                ...i,
                quantity: action.payload.quantity,
                price: action.payload.price,
                mainPirce: i.mainPrice || i.price,
              };
            } else {
              return { ...i };
            }
          }
        );

        if (updatedCartItems.length > 0) {
          const carts = state.carts.map((e, i) => {
            if (i + 1 === parseInt(tableNum)) {
              return {
                ...e,
                cartItems: updatedCartItems,
              };
            } else {
              return { ...e };
            }
          });
          const resultState = { ...state, carts: [...carts] };
          localStorage.setItem("carts", JSON.stringify(resultState.carts));
          return resultState;
        } else {
          return state;
        }
      }
    }
    case "CUSTOMER_SET_ORDERS": {
      let carts = [...state.carts];

      action.payload.orders.forEach((order) => {
        let tableNum;
        if (!order.description.tableNum) {
          const foundCarts = state.carts.filter(
            (c) => c.clientCode === order.description.clientCode
          );
          if (foundCarts.length > 0) {
            tableNum = foundCarts[0].tableNum;
          }
        }

        tableNum = tableNum || order.description.tableNum;

        carts = carts.map((e, i) => {
          if (i + 1 === parseInt(tableNum)) {
            return {
              cartItems: order.items,
              user: order.description.user,
              alert: order.description.alert || order.items[0]?.alert,
              alertTimePeriod: order.description.alertTimePeriod,
              onBusinessUser: order.description.onBusinessUser,
              tableType: order.description.tableType,
              alertOn: order.description.alertOn,
              orderCode: order.description.orderCode || uuidv4(),
              description: order.description.customerName,
              tableNum: tableNum,
              clientCode: order.items[0]?.clientCode,
              tableCode:
                order.items[0]?.tableCode || order.items[0]?.clientCode,
              partialCache: order.description.partialCache,
              partialPOS: order.description.partialPOS,
            };
          } else {
            return { ...e };
          }
        });
      });

      state.tableTypes.forEach((tt) => {
        tt?.tableNumbers.forEach((num) => {
          carts[num - 1].tableType = tt._id;
        });
      });

      if (carts.length > 0) {
        const resultState = { ...state, carts: [...carts] };
        localStorage.setItem("carts", JSON.stringify(resultState.carts));
        return resultState;
      } else {
        return state;
      }
    }
    case "CUSTOMER_CART_REMOVE_ITEMS": {
      const items = state.carts[action.payload.tableNum - 1].cartItems.filter(
        (i) => {
          if (action.payload.itemCodes.includes(i.itemCode)) {
            return true;
          }
          if (!i.tableCode) {
            return true;
          }
          return false;
        }
      );

      if (items.length > 0) {
        const carts = state.carts.map((e, i) => {
          if (i + 1 === parseInt(action.payload.tableNum)) {
            const cartItems = [...items];
            return { ...e, cartItems, tableCode: action.payload.tableCode };
          } else {
            return { ...e };
          }
        });
        const resultState = { ...state, carts: [...carts] };
        localStorage.setItem("carts", JSON.stringify(resultState.carts));
        return resultState;
      } else {
        const carts = state.carts.map((e, i) => {
          if (i + 1 === parseInt(action.payload.tableNum)) {
            return { cartItems: [], tableNum: action.payload.tableNum };
          } else {
            return { ...e };
          }
        });
        const resultState = { ...state, carts: [...carts] };
        localStorage.setItem("carts", JSON.stringify(resultState.carts));
        return resultState;
      }
    }
    case "CART_CHANGE_DESCRIPTION": {
      const carts = state.carts.map((e, i) => {
        if (i + 1 === action.payload.tableNum) {
          return {
            ...e,
            description: action.payload.description,
            alertTimePeriod: action.payload.alertTimePeriod,
            onBusinessUser: action.payload.onBusinessUser,
            alertOn: action.payload.alertOn,
          };
        } else {
          return { ...e };
        }
      });
      const resultState = { ...state, carts: [...carts] };
      localStorage.setItem("carts", JSON.stringify(resultState.carts));
      return resultState;
    }
    case "CART_CUSTOMER_CHANGE_DESCRIPTION": {
      let tableNum;
      if (!action.payload.tableNum) {
        const foundCarts = state.carts.filter(
          (c) => c.clientCode === action.payload.clientCode
        );
        if (foundCarts.length > 0) {
          tableNum = foundCarts[0].tableNum;
        }
      }

      tableNum = tableNum || action.payload.tableNum;

      const carts = state.carts.map((e, i) => {
        if (i + 1 === parseInt(tableNum)) {
          return {
            ...e,
            user: action.payload.user,
            alert: action.payload.alert,
            alertTimePeriod: action.payload.alertTimePeriod,
            onBusinessUser: action.payload.onBusinessUser,
            tableType: action.payload.tableType,
            alertOn: action.payload.alertOn,
            orderCode: action.payload.orderCode,
            description: action.payload.customerName,
          };
        } else {
          return { ...e };
        }
      });
      const resultState = { ...state, carts: [...carts] };
      localStorage.setItem("carts", JSON.stringify(resultState.carts));
      return resultState;
    }
    case "CART_REMOVE_ITEM": {
      const carts = state.carts.map((e, idx) => {
        if (idx + 1 === action.payload.tableNum) {
          const cartItems = e.cartItems.filter(
            (item, index) => index !== action.payload.item.index
          );
          return { ...e, cartItems };
        } else {
          return { ...e };
        }
      });
      const resultState = { ...state, carts: [...carts] };
      localStorage.setItem("carts", JSON.stringify(resultState.carts));
      return resultState;
    }
    case "CART_REMOVE_FIRST_TABLE": {
      const carts = state.carts.map((e, idx) => {
        if (idx === 0) {
          return { cartItems: [] };
        } else {
          return { ...e };
        }
      });
      const resultState = { ...state, carts: [...carts] };
      localStorage.setItem("carts", JSON.stringify(resultState.carts));
      return resultState;
    }
    case "CART_CUSTOMER_APPROVE": {
      const carts = state.carts.map((e, idx) => {
        if (idx + 1 === action.payload.tableNum) {
          const cartItems = e.cartItems.map((item, index) => {
            if (item.tableCode) {
              return { ...item, editable: false };
            } else {
              return {
                ...item,
                tableCode: action.payload.tableCode,
                editable: false,
                customerName: action.payload.customerName,
              };
            }
          });
          return { ...e, cartItems };
        } else {
          return { ...e };
        }
      });
      const resultState = { ...state, carts: [...carts] };
      localStorage.setItem("carts", JSON.stringify(resultState.carts));
      return resultState;
    }
    case "CART_CHANGE_ITEM_PRICE": {
      const carts = state.carts.map((e, idx) => {
        if (idx + 1 === action.payload.tableNum) {
          const cartItems = e.cartItems.map((item, index) => {
            /*if (
              item._id === action.payload.item._id &&
              (!item.feature ||
                item.feature._id === action.payload.item.feature._id)
            ) */ if (item.itemCode === action.payload.item.itemCode) {
              if (item.feature) {
                return {
                  ...item,
                  feature: {
                    ...item.feature,
                    mainPrice: item.feature.mainPrice || item.feature.price,
                    price:
                      action.payload.price - item.price < 0
                        ? 0
                        : action.payload.price - item.price,
                  },
                };
              } else {
                return {
                  ...item,
                  price: action.payload.price,
                  mainPrice: item.mainPrice || item.price,
                };
              }
            } else {
              return { ...item };
            }
          });
          return { ...e, cartItems };
        } else {
          return { ...e };
        }
      });
      const resultState = { ...state, carts: [...carts] };
      localStorage.setItem("carts", JSON.stringify(resultState.carts));
      return resultState;
    }
    case "CART_CHANGE_ITEM_DIVIDE": {
      let secondItemAfterDivide;
      let secondItemIndex;
      const carts = state.carts.map((e, idx) => {
        if (idx + 1 === action.payload.tableNum) {
          const cartItems = e.cartItems.map((item, index) => {
            if (
              item._id === action.payload.item._id &&
              (!item.feature ||
                item.feature._id === action.payload.item.feature._id)
            ) {
              secondItemAfterDivide = {
                ...item,
                quantity: action.payload.divideSecondPart,
                itemCode: uuidv4(),
              };
              secondItemIndex = index;
              return {
                ...item,
                quantity: action.payload.divideFirstPart,
              };
            } else {
              return { ...item };
            }
          });
          if (secondItemAfterDivide) {
            cartItems.splice(secondItemIndex + 1, 0, secondItemAfterDivide);
          }
          return { ...e, cartItems };
        } else {
          return { ...e };
        }
      });
      const resultState = { ...state, carts: [...carts] };
      localStorage.setItem("carts", JSON.stringify(resultState.carts));
      return resultState;
    }
    case "CART_INCREMENT_ITEM": {
      const carts = state.carts.map((e, idx) => {
        if (idx + 1 === action.payload.tableNum) {
          const cartItems = e.cartItems.map((item, index) => {
            if (index === action.payload.index) {
              return {
                ...item,
                quantity: item.quantity + action.payload.incrementValue,
              };
            } else {
              return { ...item };
            }
          });
          return { ...e, cartItems };
        } else {
          return { ...e };
        }
      });
      const resultState = { ...state, carts: [...carts] };
      localStorage.setItem("carts", JSON.stringify(resultState.carts));
      return resultState;
    }
    case "CART_DECREMENT_ITEM": {
      const carts = state.carts.map((e, idx) => {
        if (idx + 1 === action.payload.tableNum) {
          const cartItems = e.cartItems.map((item, index) => {
            if (index === action.payload.index) {
              return {
                ...item,
                quantity: item.quantity - action.payload.decrementValue,
              };
            } else {
              return { ...item };
            }
          });
          return { ...e, cartItems };
        } else {
          return { ...e };
        }
      });
      const resultState = { ...state, carts: [...carts] };
      localStorage.setItem("carts", JSON.stringify(resultState.carts));
      return resultState;
    }
    case "CART_ITEM_EDITABLE": {
      const carts = state.carts.map((e, idx) => {
        if (idx + 1 === action.payload.tableNum) {
          const cartItems = e.cartItems.map((item, index) => {
            if (index === action.payload.index) {
              return { ...item, editable: item.editable ? false : true };
            } else {
              return { ...item };
            }
          });
          return { ...e, cartItems };
        } else {
          return { ...e };
        }
      });
      const resultState = { ...state, carts: [...carts] };
      localStorage.setItem("carts", JSON.stringify(resultState.carts));
      return resultState;
    }
    case "CART_GIFT_ITEM": {
      const carts = state.carts.map((e, idx) => {
        if (idx + 1 === action.payload.tableNum) {
          const cartItems = e.cartItems.map((item, index) => {
            if (
              item.itemCode === action.payload.itemCode ||
              item.relativeItem === action.payload.itemCode
            ) {
              return { ...item, isGift: action.payload.isGift };
            } else {
              return { ...item };
            }
          });
          return { ...e, cartItems };
        } else {
          return { ...e };
        }
      });
      const resultState = { ...state, carts: [...carts] };
      localStorage.setItem("carts", JSON.stringify(resultState.carts));
      return resultState;
    }
    case "CART_PARTIAL_PAYMENT_ITEM_CHECK": {
      const carts = state.carts.map((e, idx) => {
        if (idx + 1 === action.payload.tableNum) {
          let relativeItem;
          let cartItems = e.cartItems.map((item, index) => {
            if (index === action.payload.index) {
              relativeItem = item.itemCode;
              return {
                ...item,
                isPartialPayment: action.payload.isPartialPayment,
              };
            } else {
              return { ...item };
            }
          });

          cartItems = cartItems.map((item, index) => {
            if (relativeItem === item.relativeItem) {
              return {
                ...item,
                isPartialPayment: action.payload.isPartialPayment,
              };
            } else {
              return { ...item };
            }
          });

          return { ...e, cartItems };
        } else {
          return { ...e };
        }
      });
      const resultState = { ...state, carts: [...carts] };
      localStorage.setItem("carts", JSON.stringify(resultState.carts));
      return resultState;
    }
    case "CART_PARTIAL_PAY": {
      const carts = state.carts.map((e, idx) => {
        if (idx + 1 === action.payload.tableNum) {
          const cartItems = e.cartItems.map((item, index) => {
            if (item.isPartialPayment && !item.isPartialPaid) {
              return {
                ...item,
                isPartialPaid: true,
              };
            } else {
              return { ...item };
            }
          });
          return {
            ...e,
            cartItems,
            partialCache:
              (e.partialCache ? e.partialCache : 0) +
              action.payload.partialCache,
            partialPOS:
              (e.partialPOS ? e.partialPOS : 0) + action.payload.partialPOS,
          };
        } else {
          return { ...e };
        }
      });
      const resultState = { ...state, carts: [...carts] };
      localStorage.setItem("carts", JSON.stringify(resultState.carts));
      return resultState;
    }
    case "CART_SET_STAFF_MEAL": {
      const carts = state.carts.map((e, idx) => {
        if (idx + 1 === action.payload.tableNum) {
          return { ...e, isStaffMeal: action.payload.isStaffMeal };
        } else {
          return { ...e };
        }
      });
      const resultState = { ...state, carts: [...carts] };
      localStorage.setItem("carts", JSON.stringify(resultState.carts));
      return resultState;
    }
    case "CARTITEM_SET_DELIVERED": {
      const carts = state.carts.map((e, idx) => {
        if (idx + 1 === action.payload.tableNum) {
          const cartItems = e.cartItems.map((item) => {
            if (item.itemCode === action.payload.itemCode) {
              return { ...item, delivered: true };
            } else {
              return { ...item };
            }
          });
          return { ...e, cartItems: cartItems };
        } else {
          return { ...e };
        }
      });
      const resultState = { ...state, carts: [...carts] };
      localStorage.setItem("carts", JSON.stringify(resultState.carts));
      return resultState;
    }
    case "CARTITEM_SET_ALERT_PLAYED": {
      const carts = state.carts.map((e, idx) => {
        if (idx + 1 === action.payload.tableNum) {
          const cartItems = e.cartItems.map((item) => {
            if (item.itemCode === action.payload.itemCode) {
              return { ...item, alertPlayed: true };
            } else {
              return { ...item };
            }
          });
          return { ...e, cartItems: cartItems };
        } else {
          return { ...e };
        }
      });
      const resultState = { ...state, carts: [...carts] };
      localStorage.setItem("carts", JSON.stringify(resultState.carts));
      return resultState;
    }
    case "ORDER_APPROVED": {
      const carts = state.carts.map((e, index) => {
        if (index + 1 === action.payload.tableNum) {
          return { cartItems: [], tableNum: action.payload.tableNum };
        } else {
          return { ...e };
        }
      });

      state.tableTypes.forEach((tt) => {
        tt?.tableNumbers.forEach((num) => {
          carts[num - 1].tableType = tt._id;
        });
      });

      const resultState = { ...state, carts: [...carts] };
      localStorage.setItem("carts", JSON.stringify(resultState.carts));
      return resultState;
    }
    case "USER_SIGNIN":
      return {
        ...state,
        userInfo: {
          ...action.payload,
        },
      };
    case "HELPDESK_CONNECT_TO_CLIENT": {
      const messages = localStorage.getItem("messages");
      localStorage.clear();
      localStorage.setItem("messages", messages);
      const newState = {
        carts: [...Array(400).keys()].map((v, i) => ({
          cartItems: [],
          tableNum: i + 1,
        })),
        table: 0,
        categoryHistory: [],
        historicMod: false,
        compartments: null,
        users: undefined,
        tableUsers: undefined,
        tableTypes: undefined,
        tableTypesAll: undefined,
        products: null,
        mostUsedProducts: [],
        categories: null,
        allCategories: null,
        leafCategories: [],
      };

      const userInfo = {
        ...state.userInfo,
        client: action.payload,
      };

      localStorage.setItem("userInfo", JSON.stringify(userInfo));

      return {
        ...state,
        ...newState,
        userInfo,
      };
    }
    case "HELPDESK_DISCONNECT_CLIENT": {
      const messages = localStorage.getItem("messages");
      const clients = localStorage.getItem("clients");
      localStorage.clear();
      localStorage.setItem("messages", messages);
      localStorage.setItem("clients", clients);
      const newState = {
        carts: [...Array(400).keys()].map((v, i) => ({
          cartItems: [],
          tableNum: i + 1,
        })),
        table: 0,
        categoryHistory: [],
        historicMod: false,
        compartments: null,
        products: null,
        mostUsedProducts: [],
        users: null,
        tableUsers: null,
        tableTypes: null,
        tableTypesAll: null,
        categories: null,
        allCategories: null,
        leafCategories: null,
      };

      const userInfo = {
        ...state.userInfo,
        client: null,
      };

      localStorage.setItem("userInfo", JSON.stringify(userInfo));

      return {
        ...state,
        ...newState,
        userInfo,
      };
    }
    case "USER_ADD_ADDRESS":
      const userInfo = {
        ...state.userInfo,
        addresses: [...action.payload],
      };
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
      return {
        ...state,
        userInfo,
      };
    case "USER_SIGNOUT":
      localStorage.removeItem("userInfo");
      localStorage.removeItem("shippingAddress");
      localStorage.removeItem("paymentMethod");
      localStorage.removeItem("carts");
      localStorage.removeItem("updatedAt");
      localStorage.removeItem("table");
      localStorage.removeItem("leafCategories");
      localStorage.removeItem("compartments");
      localStorage.removeItem("users");
      localStorage.removeItem("tableUsers");
      localStorage.removeItem("tableTypes");
      localStorage.removeItem("tableTypesAll");

      localStorage.clear();
      return {
        userInfo: null,
        carts: [...Array(400).keys()].map((v, i) => ({
          cartItems: [],
          tableNum: i + 1,
        })),
        messages: [],
        clients: [],
      };

    case "SAVE_PAYMENT_METHOD":
      const carts2 = state.carts.map((e, i) => {
        if (i + 1 === state.table) {
          e.paymentMethod = action.payload;
          return e;
        } else {
          return e;
        }
      });
      return { ...state, carts: [...carts2] };
    case "SELECT_TABLE":
      localStorage.setItem("table", action.payload);
      localStorage.setItem("historicMod", "false");
      return {
        ...state,
        historicMod: false,
        table: action.payload,
      };
    case "CHANGE_TABLE": {
      const carts = [...state.carts];
      const cart = { ...carts[action.payload.changeThisTableNum - 1] };
      cart.tableNum = action.payload.changeWithTableNum;
      cart.tableCode = action.payload.changeWithTableCode;
      carts[action.payload.changeThisTableNum - 1].cartItems = [];
      carts[action.payload.changeThisTableNum - 1].isStaffMeal = false;
      carts[action.payload.changeThisTableNum - 1].description = "";
      carts[action.payload.changeWithTableNum - 1] = cart;
      localStorage.setItem("carts", JSON.stringify(carts));

      return {
        ...state,
        carts: [...carts],
      };
    }
    case "OPEN_HISTORIC_MOD":
      localStorage.setItem("historicMod", "true");
      return {
        ...state,
        historicMod: true,
      };
    case "CLOSE_HISTORIC_MOD":
      localStorage.setItem("historicMod", "false");
      return {
        ...state,
        historicMod: false,
      };
    case "CATEGORY_HISTORY_ADD": {
      let index = -1;
      let found = false;
      state.categoryHistory.some((element) => {
        if (element.category === action.payload.category) {
          index++;
          found = true;
          return true;
        }
        index++;
      });
      if (!found) {
        const lastState = {
          ...state,
          categoryHistory: [
            ...[...state.categoryHistory],
            { name: action.payload.name, category: action.payload.category },
          ],
        };
        localStorage.setItem(
          "categoryHistory",
          JSON.stringify(lastState.categoryHistory)
        );
        return lastState;
      } else {
        const lastState = {
          ...state,
          categoryHistory: [...state.categoryHistory.slice(0, index + 1)],
        };
        localStorage.setItem(
          "categoryHistory",
          JSON.stringify(lastState.categoryHistory)
        );
        return lastState;
      }
    }
    case "CATEGORY_HISTORY_REMOVE": {
      let index = -1;
      state.categoryHistory.forEach((element) => {
        if (element.category === action.payload) {
          index++;
          return;
        }
        index++;
      });
      if (index === -1) return state;

      const lastState = {
        ...state,
        categoryHistory: [...state.categoryHistory.slice(0, index + 1)],
      };
      localStorage.setItem(
        "categoryHistory",
        JSON.stringify(lastState.categoryHistory)
      );
      return lastState;
    }

    case "COMPARTMENTS_UPDATED":
      localStorage.setItem("compartments", JSON.stringify(action.payload));
      return { ...state, compartments: action.payload };
    case "USERS_UPDATED":
      localStorage.setItem("users", JSON.stringify(action.payload));
      return { ...state, users: action.payload };
    case "TABLE_USERS_UPDATED":
      localStorage.setItem("tableUsers", JSON.stringify(action.payload));
      return { ...state, tableUsers: action.payload };
    case "TABLE_TYPES_UPDATED": {
      localStorage.setItem("tableTypesAll", JSON.stringify(action.payload));

      const tableTypes = action.payload.filter((tt) => tt.status);

      localStorage.setItem("tableTypes", JSON.stringify(tableTypes));

      const newCarts = [...state.carts];

      tableTypes.forEach((tt) => {
        tt?.tableNumbers.forEach((num) => {
          newCarts[num - 1].tableType = tt._id;
        });
      });

      const resultState = {
        ...state,
        tableTypes,
        tableTypesAll: action.payload,
        carts: newCarts,
      };
      localStorage.setItem("carts", JSON.stringify(resultState.carts));

      return resultState;
    }

    case "PRODUCTS_UPDATED":
      localStorage.setItem("products", JSON.stringify(action.payload.products));
      localStorage.setItem(
        "mostUsedProducts",
        JSON.stringify(action.payload.mostUsedProducts)
      );
      return {
        ...state,
        products: action.payload.products,
        mostUsedProducts: action.payload.mostUsedProducts,
      };
    case "CATEGORIES_UPDATED":
      localStorage.setItem(
        "categories",
        JSON.stringify(action.payload.categories)
      );
      localStorage.setItem(
        "allCategories",
        JSON.stringify(action.payload.allCategories)
      );
      return {
        ...state,
        categories: action.payload.categories,
        allCategories: action.payload.allCategories,
      };
    case "LEAF_CATEGORIES_UPDATED":
      localStorage.setItem("leafCategories", JSON.stringify(action.payload));
      return { ...state, leafCategories: action.payload };
    default:
      return state;
  }
}

export function StoreProvider(props) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };
  return <Store.Provider value={value}>{props.children} </Store.Provider>;
}
